var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex account-sidebar p-4" }, [
    _c("h4", { staticClass: "mr-4 mr-4 logo" }, [_vm._v("My account")]),
    _c(
      "div",
      {},
      [
        _c(
          "router-link",
          {
            staticClass: "nav-link p-lg-2 mr-3 m-lg-1",
            attrs: { to: { name: "AdminCardsCreate1" } },
          },
          [_vm._v(" Create new cards ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      {},
      [
        _c(
          "router-link",
          {
            staticClass: "nav-link p-lg-2 mr-3 m-lg-1",
            attrs: { to: { name: "AdminCardsView" } },
          },
          [
            _vm._v(" Cards "),
            _c("span", { staticClass: "sr-only" }, [_vm._v("(current)")]),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      {},
      [
        _c(
          "router-link",
          {
            staticClass: "nav-link p-lg-2 mr-3 m-lg-1",
            attrs: { to: { name: "AdminSettings" } },
          },
          [_vm._v(" Settings ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      {},
      [
        _c(
          "router-link",
          {
            staticClass: "nav-link p-lg-2 mr-3 m-lg-1",
            attrs: { to: { name: "AvailableCards" } },
          },
          [_vm._v(" Today's Cards ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      {},
      [
        _c(
          "router-link",
          {
            staticClass: "nav-link p-lg-2 mr-3 m-lg-1",
            attrs: { to: { name: "ExportCreatedBy" } },
          },
          [_vm._v(" Export Card Details ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }